export function NonNullish<T>(value: T, message?: string): NonNullable<T> {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'bigint':
      return value;

    default:
      if (!value) {
        throw new Error(message ?? 'Value must not be nullish');
      }

      return value;
  }
}

export function assertNonNullish<T>(value: T, message?: string): asserts value is NonNullable<T> {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'bigint':
      break;

    default:
      if (!value) {
        throw new Error(message ?? 'Value must not be nullish');
      }
  }
}
